/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { TRANSACTION_RENTAL, TRANSACTION_SALE } from '../enums/TransactionCodes.mjs'
import { useIntl } from 'react-intl'
import EstateTypeLabel from './labels/EstateTypeLabel'

export type EstateDescriptionProps = {
  transaction: TransactionType;
  type: EstateType;
}

function EstateDescription (props: EstateDescriptionProps) {
  const { transaction, type } = props
  const intl = useIntl()

  if (transaction === TRANSACTION_SALE) {
    return intl.formatMessage({
      id: '$_to_sell',
      defaultMessage: '{subject} à vendre'
    }, { subject: <EstateTypeLabel value={type} /> })
  }

  if (transaction === TRANSACTION_RENTAL) {
    return intl.formatMessage({
      id: '$_to_rent',
      defaultMessage: '{subject} à louer'
    }, { subject: <EstateTypeLabel value={type} /> })
  }

  return null
}

export default EstateDescription
